import { Defaults } from './types/config';

/**
 * A stub {@link Client} implementation that does nothing for all methods
 */
export class StubExperimentClient {
  getUser() {
    return {};
  }

  setUser(_user) {}

  async fetch(_user) {
    return this;
  }

  getUserProvider() {
    return null;
  }

  setUserProvider(_uerProvider) {
    return this;
  }

  variant(_key, _fallback) {
    return Defaults.fallbackVariant;
  }

  all() {
    return {};
  }

  exposure(_key) {}

}
//# sourceMappingURL=stubClient.js.map